
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 61 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.5 5c13.785 0 25 11.215 25 25s-11.215 25-25 25-25-11.215-25-25 11.215-25 25-25zm0-5C13.932 0 .5 13.432.5 30c0 16.568 13.432 30 30 30 16.568 0 30-13.432 30-30 0-16.568-13.432-30-30-30zm10.983 18.75L27.375 33.21l-6.61-6.265-4.64 4.645 11.25 10.91 18.75-19.108-4.642-4.642z","fill":"#4CAF50"}})])
          )
        }
      }
    